import React, { useState } from 'react';
import LeftIcon from '../../../assets/arrow_left.svg';
import { TravelClaimForList } from '../../../types/travelClaims';

interface Props {
    claim?: TravelClaimForList
    x: number
    y: number
    hide: () => void
    updateComment: (claim: TravelClaimForList, text: string) => void
}

export const CommentaryForm = ({claim, x, y, hide, updateComment}: Props) => {
    const [text, setText] = useState(claim?.responsible_comment);

    const handleSubmit = () => {
        if (claim && text) {
            updateComment(claim, text);
        }
    }
    return (
        <div
            className={`absolute flex overflow-hidden justify-center z-50 bg-white rounded-lg shadow-below`}
            style={{
                left: x,
                top: y,
            }}
        >
            <div className='flex flex-col min-w-[364px] text-melon-grey-darker'>
                <div
                    className='cursor-pointer rounded-t-lg p-3 shadow-below'
                    onClick={hide}
                >
                    <img
                        className='inline-block mr-[10px]'
                        src={LeftIcon}
                        alt='Go back'
                    />

                    Комментарий
                </div>

                <div className='flex flex-col p-5'>
                    <textarea
                        className='text-melon-black bg-melon-light p-4 rounded-lg mb-4 min-h-[130px] resize-none focus:outline-none'
                        rows={5}
                        placeholder='Напишите комментарий'
                        onChange={e => setText(e.target.value)}
                        value={text}
                    >

                    </textarea>

                    <button
                        className='bg-melon-yellow py-[10px] rounded-lg text-melon-black'
                        onClick={handleSubmit}
                    >
                        ОК
                    </button>
                </div>
            </div>
        </div>
    );
};
